import * as Yup from 'yup';
const yesterday = new Date(Date.now() - 86400000);
const SchemaSorteos = Yup.object({
  id: Yup.number(),
  nombre: Yup.string().required("El nombre es requerido."),
  //fecha_inicio: Yup.date().required("La fecha inicio es requerida.").min(yesterday,'La fecha debe ser minima de hoy'),
  fecha_inicio: Yup.date().when('id', (id) => {
    if (id == 0 || id == '') {
      return Yup.date().required("La fecha inicio es requerida.").min(yesterday, 'La fecha debe ser minima de hoy')
    }
  }),
  fecha_fin: Yup.date().when("fecha_inicio", (started, yup) => started && yup.min(started, "No pude ser menor a la fecha inicio"))
    .required('La fecha fin es requerida'),
  hora_fin: Yup.string().required('La hora es requerida')
});

export default SchemaSorteos;